/* eslint-disable @typescript-eslint/no-explicit-any */
import { fetchJSON } from '../Fetch';

export default async function getAccountCurrency(
  accountID: string,
): Promise<{ accountCurrency: string }> {
  let data = await fetchJSON(`/api/account/currency/${accountID}`);
  return data as any;
}
